import React from "react";
import { Checkbox, FormControlLabel } from "@mui/material";
import { Controller } from "react-hook-form";

const Checkout = React.forwardRef(
  ({ control, name, label, color, error, ...props }, ref) => {
    return (
      <FormControlLabel
        control={
          <Controller
            control={control}
            name={name}
            defaultValue={props.value || false}
            render={({ field: { onChange, value } }) => (
              <Checkbox
                inputRef={ref}
                onChange={onChange}
                checked={value}
                color={color}
                sx={{ "& .MuiSvgIcon-root": { fontSize: 18 } }}
              />
            )}
          />
        }
        label={label}
        {...(error ? { error } : {})}
        {...props}
      />
    );
  }
);

export default Checkout;
